import type { KgInsight } from '@api';
import {
  POSTHOG_TRACKING_SOURCES,
  PosthogTrackingSource,
} from '@terminal/services/tracking/posthog/constants';
import { DownloadButton } from '@terminal/views/insight-feed/components/download-button/DownloadButton';
import React from 'react';

import { CompanyCatalystBadge } from '../company-catalyst-badge/CompanyCatalystBadge';
import { ThematicCatalystBadge } from '../thematic-catalyst-badge/ThematicCatalystBadge';
import { KgInsightHeaderButton } from './KgInsightHeaderButton';
import styles from './KgInsightPreview.module.scss';

export type KgInsightHeaderActionProps = {
  subject: KgInsight['subject'];
  source?: PosthogTrackingSource;
  onDownload?: () => void;
};

export const KgInsightHeaderAction = ({
  subject,
  source = POSTHOG_TRACKING_SOURCES.CATALYST_INSIGHT_DRAWER,
  onDownload,
}: KgInsightHeaderActionProps) => {
  const catalystBadgeByMode: Partial<
    Record<KgInsight['subject']['type'], React.ReactNode>
  > = {
    entity: <CompanyCatalystBadge entityTag={subject.id} source={source} />,
    theme: <ThematicCatalystBadge themeId={subject.id} source={source} />,
    geo: <CompanyCatalystBadge entityTag={subject.id} source={source} />,
  };

  return (
    <div className={styles.headerActionWrapper}>
      <div className={styles.headerActionLeft}>
        {catalystBadgeByMode[subject.type]}
        {onDownload && (
          <DownloadButton
            onClick={onDownload}
            className={styles.downloadButton}
          />
        )}
      </div>
      <KgInsightHeaderButton subject={subject} />
    </div>
  );
};
